import { Icon as ChakraIcon } from '@chakra-ui/react'

import { IconProps } from './Icon.types'

export default function Icon(props: IconProps) {
  return <ChakraIcon {...props} />
}
